var _path, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGbp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_506_2340",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 26
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 12.6743C0 5.77076 5.59644 0.174316 12.5 0.174316C19.4036 0.174316 25 5.77076 25 12.6743C25 19.5779 19.4036 25.1743 12.5 25.1743C5.59644 25.1743 0 19.5779 0 12.6743Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_506_2340)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0.174316H25V25.1743H0V0.174316Z",
    fill: "#F4F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5 0.174316H30V25.1743H-5V0.174316Z",
    fill: "#1D3097"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 16.1743H-2L-1.5 10.1743H7L0 2.17432L0.509804 0.674316L2.03922 0.174316L9.17647 7.17432V-1.82568H15.5V7.17432L23.5 -0.796272L26 0.674316L25.5 2.17432L17.3333 10.1743H26V16.1743H18.5L22.9412 20.6743L26 24.1743V25.6743L23.9608 26.1743L15.5 18.1743V26.6743L9.5 26.1743V18.1743L2.54902 25.6743H0.509804L0 22.6743L6.5 16.1743Z",
    fill: "#F4F4FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.1743L25 0.174316",
    stroke: "#DB0033",
    strokeWidth: 1.667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 15.1743L25 25.1743",
    stroke: "#DB0033",
    strokeWidth: 1.667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10.1743L0 0.174316",
    stroke: "#DB0033",
    strokeWidth: 1.667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15.1743L0 25.1743",
    stroke: "#DB0033",
    strokeWidth: 1.667,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-4 15.4743H10.1429V28.6743H14.8571V15.4743C20.3803 15.4743 23.4769 15.4743 29 15.4743V10.8743H14.8571V-2.32568H10.1429V10.8743H-4V15.4743Z",
    fill: "#DB0033"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGbp);
export default __webpack_public_path__ + "static/media/GBP.2cd3886cf54728f3de09eb22f0936702.svg";
export { ForwardRef as ReactComponent };